import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

import { FonteIconeComponent } from "../../../fonte-icone/fonte-icone.component";

//Composant texte couleur colonne
@Component(
	{
		selector: 'val-texte-couleur-colonne',
		imports:
			[
				NgClass,
				FonteIconeComponent
			],
		templateUrl: './texte-couleur-colonne.component.html',
		styleUrl: './texte-couleur-colonne.component.scss',
	})
export class TexteCouleurColonneComponent implements OnChanges {
	//Création
	constructor(private elementRef: ElementRef) {
		this.texte = "";
		this.couleur = "";
		this.couleurFond = "";
		this.icone = "fas fa-circle";
	}

	//Valeur
	@Input()
	public valeur!: string | null;

	//Couleur par défaut
	@Input()
	public couleurParDefaut?: string | null = null;

	//Texte
	public texte: string;

	//Couleur
	public couleur: string;

	//Couleur de fond
	public couleurFond: string;

	//Icône FontAwesome
	public icone: string;

	// Recalcule l'affichage à chaque changement d'input (ex : tri de grille qui réassigne [valeur])
	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['valeur'] || changes['couleurParDefaut']) {
			this.MettreAJourAffichage();
		}
	}

	private MettreAJourAffichage(): void {
		let texteCouleur: string[];

		this.texte = "";
		this.couleur = "";
		this.couleurFond = "";
		this.icone = "fas fa-circle";

		if (this.valeur) {
			texteCouleur = this.valeur!.split('|');

			if (texteCouleur.length >= 2) {
				this.texte = texteCouleur[0];
				this.couleur = texteCouleur[1];
				this.icone = texteCouleur[2] ?? "fas fa-circle";
			}
			else {
				this.texte = this.valeur!;
				this.couleur = this.resoudreCouleurParDefaut();
			}

			if (!this.couleur)
				this.couleur = this.resoudreCouleurParDefaut();

			this.couleurFond = this.hexVersRgba(this.couleur, 0.2);
		}
	}

	private resoudreCouleurParDefaut(): string {
		// Si une couleur hex est fournie en input, on l'utilise directement
		if (this.couleurParDefaut?.startsWith('#')) {
			return this.couleurParDefaut;
		}

		// Sinon on lit la valeur résolue de --couleur-principale dans le DOM
		const valeurCss = getComputedStyle(this.elementRef.nativeElement)
			.getPropertyValue('--couleur-principale')
			.trim();

		return valeurCss;
	}

	private hexVersRgba(hex: string, opacite: number): string {
		const couleurHex = hex.replace('#', '');
		const r = parseInt(couleurHex.slice(0, 2), 16);
		const g = parseInt(couleurHex.slice(2, 4), 16);
		const b = parseInt(couleurHex.slice(4, 6), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacite})`;
	}
}
